/**
 * Modules of the single app. Order defines the "first allowed module" used in redirects.
 * Module ids are domain identifiers (they appear in /auth/me and data-module) and match the paths.
 */
export const MODULES = ['one', 'emdia', 'carreiras', 'conquistas', 'eventos', 'conta'] as const
export type ModuleId = (typeof MODULES)[number]

/** Base path of each module (reserved paths — ONE, at the root, never uses the other prefixes). */
export const MODULE_PATH: Record<ModuleId, string> = {
  one: '/',
  emdia: '/parcelas',
  carreiras: '/carreiras',
  conquistas: '/conquistas',
  eventos: '/eventos',
  conta: '/conta',
}

/** Conta UniFECAF is always allowed (sign in, password, devices). */
export const ALWAYS_ALLOWED: readonly ModuleId[] = ['conta']
